'use strict';

/**
 * Auth0 authentication provider for AngularJS.
 * Wraps angularAuth0 and provides a consistent API compatible with the authService facade.
 *
 * Shared across QuartzX legacy projects. Keep in sync with QuartzX.Web.IAM.Legacy.
 *
 * @module services.auth0Provider
 */
angular.module('services.auth0Provider', [])

.factory('auth0Provider', ['$q', '$location', '$window', '$injector', function($q, $location, $window, $injector) {
  var service = {};
  var angularAuth0 = null;

  /**
   * Lazily retrieve angularAuth0 service.
   * Only loads when actually needed, preventing crashes when using Keycloak.
   */
  function getAngularAuth0() {
    if (!angularAuth0) {
      angularAuth0 = $injector.get('angularAuth0');
    }
    return angularAuth0;
  }

  /**
   * Initialize Auth0.
   * Auth0 SDK is already initialized via module config, so this is a no-op.
   */
  service.init = function(options) {
    var deferred = $q.defer();
    deferred.resolve(true);
    return deferred.promise;
  };

  service.isAuthenticated = function() {
    return getAngularAuth0().isAuthenticated();
  };

  service.user = function() {
    return getAngularAuth0().getUser();
  };

  service.getAccessToken = function() {
    return getAngularAuth0().getTokenSilently();
  };

  service.login = function(appStateTarget) {
    appStateTarget = appStateTarget || null;
    return getAngularAuth0().loginWithRedirect({
      appState: {
        target: appStateTarget || $location.url(),
      }
    });
  };

  service.logout = function() {
    return getAngularAuth0().logout({
      returnTo: window.location.origin
    });
  };

  /**
   * Handle Auth0 OAuth callback.
   * Only processes callback if OAuth parameters are present in URL.
   */
  service.handleAuthentication = function() {
    var search = $window.location.search;
    var hasCallbackParams = search.indexOf('code=') !== -1 && search.indexOf('state=') !== -1;

    if (!hasCallbackParams) {
      var deferred = $q.defer();
      deferred.resolve(null);
      return deferred.promise;
    }

    return getAngularAuth0().handleRedirectCallback()
      .then(function(cbRes) {
        var targetRoute = cbRes.appState && cbRes.appState.target
          ? cbRes.appState.target
          : '/';
        return targetRoute;
      })
      .catch(function(err) {
        console.error('[auth0Provider] handleRedirectCallback error:', err);
        return null;
      });
  };

  return service;
}]);
